import * as GUI from "babylonjs-gui"

// Exported object that tracks radio buttons by group name
export const radioButtonGroups: { [groupName: string]: GUI.RadioButton[] } = {}
